import styled, { css } from 'styled-components';
import { Flex, mediaMixin, token } from '@zillow/constellation';

export const StyledDiv = styled.div`
  height: 110px;

  ${mediaMixin(
    'md',
    css`
      height: 190px;
    `,
  )}
`;

export const StyledHeroBackground = styled(Flex)`
  width: 100%;
  background-color: ${token('colors.coolGray100')};
  height: 80px;

  ${mediaMixin(
    'md',
    css`
      height: 144px;
    `,
  )}
`;
